import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

let { ethereum } = window;
if(ethereum && ethereum.providerMap) {
  ethereum.providerMap.forEach(element => {
    if(element.isMetaMask) {
      ethereum = element
    }
  });
}

export default new Vuex.Store({
  state: {
    // loader : false,
    member: null,
    transactionData: null,
    withdrawData: null,
    account: null,
    address: null,
    error: null,
    chainId: null,
    balance: null,
    convertedBalance: 0,
    convertedPurchased: 0,
    convertedReferral: 0,
    totalSupply: 0,
    paymentData: null,
    kycData: null
  },
  mutations: {
    setAccount(state, account) {
      state.account = account;
    },
    setChainId(state, chainId) {
      state.chainId = chainId;
    },
    setAddress(state, address) {
      state.address = address;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setError(state, error) {
      state.error = error;
    },
    setMember(state, member) {
      state.member = member;
      localStorage.setItem('USER', JSON.stringify(member));
    },
    setTransactionData(state, transactionData) {
      state.transactionData = transactionData
    },
    setWithdrawData(state, withdrawData) {
      state.withdrawData = withdrawData
    },
    setPaymentData(state, paymentData) {
      state.paymentData = paymentData
    },
    setKycData(state, kycData) {
      state.kycData = kycData
    },
    setWalletDetail(state, metamask) {
      state.metamask = metamask;
    },
    setConvertedBalance(state, convertedBalance) {
      state.convertedBalance = convertedBalance;
    },
    setConvertedPurchased(state, convertedPurchased) {
      state.convertedPurchased = convertedPurchased;
    },
    setConvertedReferral(state, convertedReferral) {
      state.convertedReferral = convertedReferral;
    },
    setTotalSupply(state, totalSupply) {
      state.totalSupply = totalSupply;
    }
  },
  actions: {	
    async connect({ commit, dispatch }, connect) {
      try {
        // const { ethereum } = window;
        if (!ethereum) {
          commit("setError", "Metamask not installed!");
          return;
        }
        if (!(await dispatch("checkIfConnected")) && connect) {
          await dispatch("requestAccess");
        }
        await dispatch("checkNetwork");
      } catch (error) {
        console.log(error);
        commit("setError", "Account request refused.");
      }
    },
    async checkNetwork({ commit }) {
      let chainId = await ethereum.request({ method: "eth_chainId" });
      commit("setChainId", parseInt(chainId));
      // const rinkebyChainId = "0x4";
      // if (chainId !== rinkebyChainId) {
      //   if (!(await dispatch("switchNetwork"))) {
      //     commit(
      //       "setError",
      //       "You are not connected to the Rinkeby Test Network!"
      //     );
      //   }
      // }
    },
    async switchNetwork({ commit }, chain) {
      try {
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chain }],
        });
        commit("setChainId", parseInt(chain))
        // return 1;
      } catch (switchError) {
        // return 0;
      }
    },
    async checkIfConnected({ commit,dispatch }) {
      // const { ethereum } = window;
      const accounts = await ethereum.request({ method: "eth_accounts" });
      if (accounts.length !== 0) {
        commit("setAccount", accounts[0]);
        commit("setAddress", accounts[0].substring(0,6)+'...'+accounts[0].substring(accounts[0].length-4));
        await dispatch("getBalance", accounts[0]);
        return 1;
      } else {
        return 0;
      }
    },
    async requestAccess({ commit }) {
      // const { ethereum } = window;
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      commit("setAccount", accounts[0]);
      commit("setAddress", accounts[0].substring(0,6)+'...'+accounts[0].substring(accounts[0].length-4));
    },
    async disconnect({ commit }) {
      if(this.state.address) {
        commit("setAccount", null);
        commit("setAddress", null);
      }
    },
    async getBalance({ commit },account) {
      try {
        const balance = await ethereum.request({
          method: "eth_getBalance",
          params: [account,'latest'],
        });
        commit("setBalance", parseInt(balance, 16) / Math.pow(10,18))
      } catch (err) {
        console.log(err);
      }
    },
  },
  getters: {
    account: (state) => state.account,
    address: (state) => state.address,
    balance: (state) => state.balance,
    error: (state) => state.error,
    chainId: (state) => state.chainId,
    member(state) {
      return state.member;
    }

  },
  modules: {
    app,
    appConfig,
    verticalMenu
  },
  plugins: [createPersistedState()],
  strict: process.env.DEV,
})



// WEBPACK FOOTER //
// ./src/store/index.js